import React from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import IconButton from "@mui/material/IconButton";
import SvgIcon from "@mui/material/SvgIcon";

import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../analytics";
import WithPingPilotCheck from "../hocs/withPingPilotCheck";
import {LookCoBrowseIcon} from "../../common/icons";
import COLOR_THEMES from "../../../colorThemes";


const ShopPingPilotButton = (props) => {

  const {intl, pingButton, activeTheme} = props;

  const pingPilotButtonClick = () => {
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.shopHelpChat);
    pingButton.click();
  }

  return (
    <div className={"look-cart-button shop-help ping-pilot-visualizer-button"}>
      <IconButton aria-label={intl.formatMessage({id: "iconButton.help"})}
                  className="look-icon look-icon--white2 look-icon--with-shadow"
                  onClick={pingPilotButtonClick}>
        <SvgIcon>
          <LookCoBrowseIcon color={COLOR_THEMES[activeTheme].primary}/>
        </SvgIcon>
      </IconButton>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {isMobile, activeTheme} = store.serverState;

  return {
    isMobile,
    activeTheme,
  };
};

export default injectIntl(connect(mapStateToProps)(WithPingPilotCheck(ShopPingPilotButton)))
